import BaseApi from "@/core/HttpResources/BaseApi";

export default class BudgetExpenseService {
  baseApiPublish = new BaseApi("BudgetExpense");
  async getBudgetExpenses(): Promise<any> {
    return new Promise<any>((resolve, reject) =>
      this.baseApiPublish.request(
        "GET",
        "GetAll",
        null,
        {},
        response => resolve(response.data),
        reject,
        () => {}
      )
    );
  }
}